import { useCallback, useContext, useEffect, useState } from "react";
import axios from "../../../api/axios";
import { sleep } from "../../../functions";
import DataContext from "./context";
import useAlert from "../../../globalComponents/useAlerts";

export const useDataManager = () => {
  const [loading, setLoading] = useState(false);
  const [dashboard, setDashboard] = useState({
    totalCustomers: 0,
    totalRedeemed: 0,
    totalRewards: 0,
    totalSalesAmount: 0,
    lastCustomers: [],
  });

  const { showLoading, showAlert, dismissLoading } = useAlert();

  const getInfo = async () => {
    try {
      setLoading(true);
      const data = await axios.get("/dashboard");

      setDashboard((c) => ({ ...c, ...data }));

      setTimeout(() => setLoading(false), 1500);
    } catch (err) {
      showAlert({
        title: "Erro",
        description: "Verifique os parâmetros enviados e tente novamente.",
        //onClose: () => window.location.reload(),
      });
    } finally {
    }
  };

  useEffect(() => {
    getInfo();
  }, []);

  return {
    loading,
    dashboard,
  };
};

export const useData = () => useContext(DataContext);
